import type { OfferLabelsTranslation } from '../../offer-labels-content';

export const offerLabels: OfferLabelsTranslation = {
  bestPlaceBadge: 'Nossa escolha',
  bestPriceBadge: 'Melhor preço',
};
